import { Entity } from '../../entity';
import { ActivityEntityName } from '../../shared/activity.entity.name';
import { ContactEntity } from '../../contact/contact.options';
import { EntityViewDisplay, EntityViewSortDirection, EntityViewVisibility } from '../../entities/views/enums';
import { EntityAdvancedFilterGroup } from '../../entities/views/entity.view.advanced.filter';
import { DomainType } from '../../../utilities/domain.utility';

export enum EntityQueueType {
  Entity = 'entity',
  Flag = 'flag',
}

export enum EntityQueueFieldSource {
  Entity = 'entity',
  Flag = 'flag',
}

export interface EntityQueueFieldRef {
  source: EntityQueueFieldSource;
  path: string;
}

export interface EntityQueueTableField {
  ref: EntityQueueFieldRef;
  name?: string;
  visible: boolean;
}

export interface EntityQueueTableConfig {
  pageSize?: number;
  display: EntityViewDisplay;
  fixed: EntityQueueTableField[];
  other: EntityQueueTableField[];
  sortBy?: EntityQueueFieldRef | null;
  sortOrder?: EntityViewSortDirection;
}

export interface EntityQueueCardConfig {
  identifier?: string;
  title?: string;
  description?: string;
  status?: string;
  body?: string[];
  footer?: string[];
  sortBy?: EntityQueueFieldRef | null;
  sortOrder?: EntityViewSortDirection;
}

export type EntityQueueAppearanceTone =
  | 'gray' | 'brand'
  | 'indigo' | 'fuchsia' | 'pink' | 'purple'
  | 'orangeDark' | 'blueLight' | 'moss';

export interface EntityQueueAppearance {
  tone?: EntityQueueAppearanceTone;
  icon?: string;
}

export interface EntityQueue extends Entity {
  name: string;
  nameKey?: string;
  system?: boolean;
  createdBy?: string;
  type: EntityQueueType;
  visibility: EntityViewVisibility;
  sharedWith?: ContactEntity[];
  appearance?: EntityQueueAppearance;
  domain?: DomainType;
  variant?: string;

  // Entity queue fields
  entity?: ActivityEntityName;
  entityFilter?: EntityAdvancedFilterGroup<any>;
  // Leaf field paths referenced by entityFilter, derived on save. An empty or
  // absent array means the filter does not narrow by field — any change to the
  // entity type is eligible (match-all).
  entityFilterFields?: string[];

  // Flag queue fields
  targetEntity?: ActivityEntityName;
  flagCategoryIds?: string[];
  flagFilter?: EntityAdvancedFilterGroup<any>;
  // Leaf field paths referenced by flagFilter, derived on save. Empty/absent
  // means match-all (see entityFilterFields).
  flagFilterFields?: string[];

  // Deterministic hash of the effective filter inputs, derived on save.
  // Equivalent queues share a signature so counts can be computed once per
  // signature/scope rather than per queue.
  filterSignature: string;

  table: EntityQueueTableConfig;
  card?: EntityQueueCardConfig;
}
